import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Logo } from "@/components/ui/Logo";
import { cn } from "@/lib/cn";
import { useRole } from "@/hooks/useRole";
import { useEffect } from "react";
import { LayoutDashboard, Sparkles, FolderKanban, LineChart, LogOut } from "lucide-react";
import { setRole } from "@/lib/auth-mock";

const nav = [
  { to: "/portal", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/portal/spark", label: "Spark", icon: Sparkles },
  { to: "/portal/deliverables", label: "Deliverables", icon: FolderKanban },
  { to: "/portal/roi", label: "ROI", icon: LineChart },
];

export default function PortalLayout() {
  const role = useRole();
  const navigate = useNavigate();
  useEffect(() => {
    if (role === "guest") navigate("/portal/login", { replace: true });
  }, [role, navigate]);

  return (
    <div className="min-h-screen flex">
      <aside className="hidden md:flex w-64 flex-col border-r border-ink-700/60 bg-ink-950/80">
        <div className="p-6"><Logo /></div>
        <div className="eyebrow px-6 mb-2">// Client Portal</div>
        <nav className="flex-1 px-3 space-y-1">
          {nav.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 rounded-md px-3 py-2.5 font-display text-sm uppercase tracking-wider transition",
                  isActive
                    ? "bg-brand-blue/15 text-brand-blue border-l-2 border-brand-blue"
                    : "text-silver-200 hover:bg-ink-800 hover:text-silver-50",
                )
              }
            >
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-ink-700/60">
          <button
            onClick={() => { setRole("guest"); navigate("/portal/login"); }}
            className="btn-ghost w-full justify-center"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <div className="h-16 border-b border-ink-700/60 bg-ink-950/60 backdrop-blur flex items-center px-6">
          <div className="eyebrow">// Harbor Dental · Phase 2 · BSS 82</div>
        </div>
        <div className="p-6 md:p-10"><Outlet /></div>
      </main>
    </div>
  );
}
